import { makeStyles, Paper, PaperProps } from "@material-ui/core";

export default function LyfePaper(props: PaperProps) {
	const classes = useStyles();

	return <Paper {...props} elevation={0} className={`${classes.paper} ${props.className}`} />;
}

const useStyles = makeStyles((theme) => ({
	paper: {
		borderRadius: theme.shape.borderRadius * 2,
	},
}));
